export const getCompanySearchLink = (companyName: string, companyId?: string | number) => {
  if (companyId !== undefined && companyId !== null && companyId !== '') {
    return `/company/${companyId}`;
  }

  const params = new URLSearchParams();
  params.set('tab', 'search');
  params.set('company', companyName);
  if (companyId !== undefined && companyId !== null && companyId !== '') {
    params.set('companyId', String(companyId));
  }
  return `/?${params.toString()}`;
};
